import { useEffect, useState } from 'react'
import { Image } from '@chakra-ui/react'

function Thumb({ file }) {
    const [thumb, setThumb] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!file) {
            setThumb(null)
            return
        }

        setLoading(true)
        const reader = new FileReader()

        reader.onloadend = () => {
            setThumb(reader.result)
            setLoading(false)
        }

        reader.readAsDataURL(file)

        // Cleanup opcional si el componente se desmonta
        return () => reader.abort()
    }, [file])

    if (!file) return null
    if (loading) return <p>loading...</p>

    return (
        <Image
            src={thumb}
            boxSize="150px"
            objectFit="cover"
            alt={file.name}
            borderRadius="md"
        />
    )
}

export default Thumb